import '@accessible360/accessible-slick';

export const Team = (() => {
	'use strict';

	function init() {
		$('.posts').slick({
			infinite: true,
			dots: false,
			arrows: false,
			speed: 1000,
			cssEase: 'linear',
			autoplay: false,
			autoplaySpeed: 0,
			slide: 'div',
			focusOnSelect: true,
			pauseOnHover: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '36px',
					}

				}
			]
		});
	}

	return {
		init: init,
		name: 'slideshow'
	};
})();
